import axios from "axios";
import parseQueryFilters from "../utils/parseQueryFilters";
import { firstError, parseResponseErrors } from "./../utils/errors";

export const getApiBaseUrl = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case "local":
      return "https://api.eventos2.local/v1/";
    case "development":
      return "https://api-dev.eventos.fi/v1/";
    case "demo":
      return "https://api-demo.eventos.fi/v1/";
    case "staging":
      return "https://api-staging.eventos.fi/v1/";
    case "production":
      return "https://api.eventos.fi/v1/";
    default:
      return "https://api.eventos2.local/v1/";
  }
};

export const getUploadsBaseUrl = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case "local":
      return "https://api.eventos2.local";
    case "development":
      return "https://api-dev.eventos.fi";
    case "demo":
      return "https://api-demo.eventos.fi";
    case "staging":
      return "https://api-staging.eventos.fi";
    case "production":
      return "https://api.eventos.fi";
    default:
      return "https://api.eventos2.local";
  }
};

// Create new axios instance
const axiosInstance = new axios.create();

// Defaults for axios
axiosInstance.defaults.baseURL = getApiBaseUrl();
axiosInstance.service =
  "f5c60e268955e61a072ff3ab545f2411e349b09c177dc97aa050c435d75b148c";

// Request interceptor
axiosInstance.interceptors.request.use(config => {
  // Always add token to request headers
  const token = localStorage.getItem("token");
  config.headers.Authorization = token ? `${token}` : "";
  config.mode = "no-cors";

  if (config.params) {

    const { order, filter } = config.params;

    // Parse order parameters for API
    if (order && order.length) {
      const orderParams = config.params.order.reduce((order, item, index) => {
        order["order[" + item.column + "]"] = item.direction;
        return order;
      }, {});
      delete config.params.order;
      config.params = { ...config.params, ...orderParams };
    }

    // Parse filters for API
    if (filter) {
      let parsedFilters = parseQueryFilters(config.params.filter);
      // Delete unnecessary params.filter
      delete config.params.filter;
      // Merge filters to config object
      config.params = { ...config.params, ...parsedFilters };
    }

  }


  return config;
});

// Response interceptor
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      localStorage.setItem("connection", 0);
      throw error.request;
    } else {
      // Something happened in setting up the request that triggered an Error
      localStorage.setItem("connection", 1);
    }

    return Promise.reject(checkForErrorDetails(error.response));
  }
);

function checkForErrorDetails(error) {
  // Parse all errors to response
  const parsedErrors = parseResponseErrors(error);
  if (parsedErrors !== false) {
    error.errors = parsedErrors;
  }
  // Parse first error item to response
  const firstErrorItem = firstError(error);
  if (firstErrorItem !== false) {
    error.firstError = firstErrorItem;
  }
  return error;
}

export default axiosInstance;
